export enum PhoneNumberType {
  Mobile = 'mobile',
  Landline = 'landline',
}

const germanMobilePrefixes: string[] = [
  '0151',
  '0152',
  '0155',
  '0156',
  '0157',
  '0159',
  '0160',
  '0162',
  '0163',
  '0164',
  '0170',
  '0171',
  '0172',
  '0173',
  '0174',
  '0175',
  '0176',
  '0177',
  '0178',
  '0179',
];

export class PhoneNumberHelpers {
  public static classifyPhoneNumber(number: string): PhoneNumberType {
    // Normalize number: remove spaces, dashes, parentheses
    const normalized: string = number.replace(/[^\d+]/g, '');

    // Check if it's a German number
    const isGerman: boolean = normalized.startsWith('+49') || normalized.startsWith('0049');

    // If it's not German, assume mobile
    if (!isGerman) {
      return PhoneNumberType.Mobile;
    }

    // Extract the national part
    let national: string;

    if (normalized.startsWith('+49')) {
      national = normalized.slice(3);
    } else {
      national = normalized.slice(4); // for 0049
    }

    // Remove leading zero if exists
    if (national.startsWith('0')) {
      national = national.slice(1);
    }

    // Compose prefix with 0 again to match standard form (e.g., 0176)
    const prefix = '0' + national.slice(0, 3);

    if (germanMobilePrefixes.includes(prefix)) {
      return PhoneNumberType.Mobile;
    }

    return PhoneNumberType.Landline;
  }
}
